import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { Link } from "react-router-dom";
import { FoundQuote } from "./Quotes";

const QuoteIDCell = (props: GridCustomCellProps) => {
  if (!props.field || props.rowType !== 'data') return null;

  const data = props.dataItem as FoundQuote;

  return <td {...props.tdProps}>
    <Link
      to={`/Quote/Index/${data.QuoteID}`}
      target="_blank"
      style={{ color: data.Unassigned ? '#28a745' : '#007bff' }}
    >
      {data.QuoteID}
      {data.DeclinedOfferCount > 0 && <div className="recent-red-circle">{data.DeclinedOfferCount}</div>}
      {data.ExpiredOfferCount > 0 && <div className="recent-orange-circle">{data.ExpiredOfferCount}</div>}
      {data.AcceptedOfferCount > 0 && <div className="recent-green-circle">{data.AcceptedOfferCount}</div>}
    </Link>
  </td>
}

export default QuoteIDCell;